import { render, staticRenderFns } from "./EtapaFormulario.vue?vue&type=template&id=5596c618"
import script from "./EtapaFormulario.vue?vue&type=script&lang=js"
export * from "./EtapaFormulario.vue?vue&type=script&lang=js"
import style0 from "./EtapaFormulario.vue?vue&type=style&index=0&id=5596c618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports